        <div class="container">
          <div class="row">
            <div class="col-12 text-center capabilityImage" >        
                <img src="../../../assets/images/blogs/mit.png" alt="mit capability statement" class="img-responsive capabilityImageTag" >
            </div>
          </div>
        </div>
        <br>